import axios from "axios";

const CMS_API = "https://cms.iamironlady.com/wp-json/wp/v2";
const STORIES_PER_PAGE = 10;

let taxonomyCache = null;

const isYoutubeUrl = (url) =>
  typeof url === "string" &&
  /youtu(?:\.be|be\.com)/i.test(url);

const getFeaturedImageUrl = (story) =>
  story?._embedded?.["wp:featuredmedia"]?.[0]?.source_url || "";

const mapCmsStory = (story, taxonomies = null) => {
  const programIds = story.success_story_program || [];
  const programNames = taxonomies
    ? programIds
        .map((id) => taxonomies.programs.find((item) => item.id === id)?.name)
        .filter(Boolean)
    : [];

  return {
    postId: story.id,
    pageTitle: story.page_title || story.title?.rendered || "",
    fullNameOfStoryTeller:
      story.full_name_of_the_story_teller || story.title?.rendered || "",
    fullNameOfStoryTellerDesignation: story.designation || "",
    successStoryPostYouTubeLink: isYoutubeUrl(story.post_detail_url)
      ? story.post_detail_url
      : "",
    successStoryPostImageLink: getFeaturedImageUrl(story),
    introductionOfTheStoryTeller: story.introduction_of_the_story_teller || "",
    situationOfTheStoryTeller: story.situation_of_the_story_teller || "",
    principalAppliedByTheStoryTeller:
      story.principles_applied_by_the_story_teller || "",
    actionTakenByTheStoryTeller: story.action_taken_by_the_story_teller || "",
    resultsAchievedByTheStoryTeller: story.results_achieved || "",
    linkedinURL: story.linkedin_url || "",
    program: programNames,
    success_story_program: programIds,
    success_story_industry: story.success_story_industry || [],
    success_story_function: story.success_story_function || [],
  };
};

const getTaxonomies = async () => {
  if (taxonomyCache) {
    return taxonomyCache;
  }

  const [programs, industries, functions] = await Promise.all([
    axios.get(`${CMS_API}/success_story_program`, { params: { per_page: 100 } }),
    axios.get(`${CMS_API}/success_story_industry`, { params: { per_page: 100 } }),
    axios.get(`${CMS_API}/success_story_function`, { params: { per_page: 100 } }),
  ]);

  taxonomyCache = {
    programs: programs.data,
    industries: industries.data,
    functions: functions.data,
  };

  return taxonomyCache;
};

const fetchCmsStories = async (params = {}) => {
  const response = await axios.get(`${CMS_API}/success_story`, {
    params: {
      per_page: STORIES_PER_PAGE,
      _embed: true,
      ...params,
    },
  });

  const taxonomies = await getTaxonomies();
  const totalPost = Number(response.headers["x-wp-total"] || 0);
  const totalPage = Number(response.headers["x-wp-totalpages"] || 0);

  return {
    stories: response.data.map((story) => mapCmsStory(story, taxonomies)),
    totalPost,
    totalPage,
  };
};

export const fetchStoriesDataFromCms = async (pageNumber) => ({
  statusCode: 200,
  data: (await fetchCmsStories({ page: pageNumber })).stories,
});

export const fetchInspirationDataFromCms = async (pageNumber) => {
  const { stories, totalPage } = await fetchCmsStories({ page: pageNumber });
  return {
    totalPage,
    postData: stories,
  };
};

export const getCountsFromCms = async () => {
  const taxonomies = await getTaxonomies();
  const { totalPost, totalPage } = await fetchCmsStories({ page: 1, per_page: 1 });

  return {
    totalPost,
    totalPage,
    programObj: taxonomies.programs.map((item) => ({
      id: item.id,
      programId: item.id,
      programName: item.name,
    })),
    IndustryObj: taxonomies.industries.map((item) => ({
      id: item.id,
      industryId: item.id,
      industryName: item.name,
    })),
    functionObj: taxonomies.functions.map((item) => ({
      id: item.id,
      functionId: item.id,
      functionName: item.name,
    })),
  };
};

export const getCatgoryDataFromCms = async (params = {}) => {
  const cmsParams = { page: 1, per_page: 100 };

  if (params.programId) {
    cmsParams.success_story_program = params.programId;
  }
  if (params.industryId) {
    cmsParams.success_story_industry = params.industryId;
  }
  if (params.functionId) {
    cmsParams.success_story_function = params.functionId;
  }

  const { stories, totalPost } = await fetchCmsStories(cmsParams);

  return {
    successStoryDetails: stories,
    storyCount: totalPost,
  };
};

export const getIndividualAuthorFromCms = async (storyId) => {
  const response = await axios.get(`${CMS_API}/success_story/${storyId}`, {
    params: { _embed: true },
  });
  const taxonomies = await getTaxonomies();
  return mapCmsStory(response.data, taxonomies);
};
